import React from "react";
import {useIntl} from "react-intl";
import ReactDOM from "react-dom";
import logoImage from "../../assets/svgs/sitebunny_logo.svg";
import ErrorCodeIcon from "../icon/ErrorCodeIcon";
import useRouteHandler from "../../hook/useRouteHandler";

type View40XProps = {
    code: string;
    title: string;
    description: string;
    customReset?: () => void;
    resetErrorBoundary?: () => void;
}

const ErrorView: React.FC<View40XProps> = (props) => {
    const { code, title, description, customReset, resetErrorBoundary } = props;
    const intl = useIntl();

    const { resetRoute } = useRouteHandler();

    const onClickReturnHome = () => {
        if (customReset) {
            customReset();
        } else {
            resetRoute();
            resetErrorBoundary?.();
        }
    }

    return ReactDOM.createPortal((
        <div className="bg-error-page bg-cover bg-center">
            <div className="flex flex-col items-center justify-center mx-auto h-screen">
                <div className="min-w-[560px] flex flex-col items-center justify-between bg-white rounded-[20px] shadow-[0_4px_8px_0_rgba(16,24,64,0.08)] max-w-md pt-[97px] pb-[77px] px-[80px]">
                    <div className="flex flex-col items-center mb-[72px]">
                        <div className="flex justify-center items-center space-x-3 pb-[64px]">
                            <img src={logoImage} alt={"logo"} width={32} height={32}/>
                            <p className="font-pretendard text-[26px] font-bold tracking-[0.52px] text-console-black">SiteBunny</p>
                        </div>
                        <div className="relative">
                            <ErrorCodeIcon/>
                            <div className="absolute top-[56px] left-[60px] font-semibold text-[22px] font-pretendard text-bunny-default">{code}</div>
                        </div>
                        <h1 className="text-center font-bold text-[16px] text-bunny-default mt-10 mb-6">
                            {title}
                        </h1>
                        <div className="text-center font-pretendard text-bunny-gray-900 text-[14px] whitespace-pre-wrap">
                            {description}
                        </div>
                    </div>

                    <button className="console-btn-5xl-primary w-full"
                            onClick={onClickReturnHome}>
                        {intl.formatMessage({id: "e0011"})}
                    </button>
                </div>
            </div>
        </div>
    ), document.getElementById('portal')!);
};

type Error404ViewProps = {
    reset?: () => void;
}

export const Error404View: React.FC<Error404ViewProps> = (props) => {
    const intl = useIntl();

    return <ErrorView code="404"
                      title={intl.formatMessage({id: "e0003"})}
                      description={intl.formatMessage({id: "e0004"})}
                      customReset={props.reset}
    />;
};

export default ErrorView;
